import React from 'react';
import PropTypes from 'prop-types';
import connectedRouterHOC from '../../utils/connectedRouterHOC';
import { 
	saveTag, 
	clearTag, 
	requestTag, 
	createNewTag 
} from '../../reducers/tags';
import TagForm from './tagForm';
import MessagePanel from '../messagePanel';
import { showSuccessNotification } from '../../reducers/notifications';
import { canEditAnyPeriod } from '../../selectors/canEdit';
import PageLayout from '../pageLayout';

class TagMaintenance extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			tag: props.tag,
			hasUnsavedChanges: false
		};

		this.updateField = this.updateField.bind(this);
	}
	static fetchData(dispatch, props) {
		if (props.match.params.tagId) {
			dispatch(requestTag(props.match.params.tagId));
		} else {
			dispatch(createNewTag());
		}
	}
	static clearData(dispatch) {
		dispatch(clearTag());
	}
	componentDidMount() {
		TagMaintenance.fetchData(this.props.dispatch, this.props);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		this.setState({
			tag: nextProps.tag,
			hasUnsavedChanges: false
		});
	}

	updateField(field, newValue) {
		const tag = this.state.tag;
		tag[field] = newValue;
        this.setState({
			tag,
			hasUnsavedChanges: true
        });
	}

	render() {
		const tag =  this.state.tag || {};

		return (
<PageLayout
	title={tag.name}
	isLoading={this.props.isLoading || this.props.saveResult.progress}
	formActions={{
		isLoading: this.props.isLoading || this.props.saveResult.progress,
		canEdit: this.props.canEdit,
		hasUnsavedChanges: this.state.hasUnsavedChanges,
		onSave: () => this.props.saveChanges(this.state.tag),
		onSaveAndContinue: () => this.props.saveChangesAndContinue(this.state.tag),
		onCancel: () => this.props.history.goBack()
	}}
	content={
		<div>
		<TagForm 
			tag={tag} 
			isLoading={this.props.isLoading} 
			saveResult={this.props.saveResult}  
			updateField={this.updateField}
		/>
		
		<MessagePanel isSuccess={this.props.saveResult.success} message={this.props.saveResult.message} />
		</div>
	}
/>
		);
	}
}

TagMaintenance.propTypes = {
	dispatch: PropTypes.func.isRequired,
	saveChanges: PropTypes.func.isRequired,
	saveChangesAndContinue: PropTypes.func.isRequired,
	tag: PropTypes.object.isRequired,
	canEdit: PropTypes.bool.isRequired,
	isLoading: PropTypes.bool.isRequired,
	saveResult: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
	tag: state.tags.tag,
	canEdit: canEditAnyPeriod(state, 'EditTags'),
	isLoading: state.tags.isLoading,
	saveResult: state.tags.saveResult
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	dispatch,
	saveChanges: (tag) => {
		dispatch(saveTag(tag, (data) => {
			dispatch(showSuccessNotification(data.message));
			ownProps.history.goBack();
		}));
	},
	saveChangesAndContinue: (tag) => {
		dispatch(saveTag(tag, (data) => {
			dispatch(showSuccessNotification(data.message));
		}));
	}
});

export default connectedRouterHOC(
	mapStateToProps,
	mapDispatchToProps
)(TagMaintenance);
